// import facebook from '../assets/images/facebook.svg';
// import youtube from '../assets/images/youtube.svg';
// import linkedin from '../assets/images/linkedin.svg';
// import twitter from '../assets/images/twitter.svg';
// import instagram from '../assets/images/instagram.svg';
// import consolidated from '../assets/images/consolidated.svg';
// import drivenmarketing from '../assets/images/drivenmarketing.svg';
// import quickonboading from '../assets/images/quickonboading.svg';

export const activateStatusType = {
  active: 'activate',
  deActivated: 'deactivate',
  invite: 'invite',
};
export const statusType = {
  open: '1',
  closed: '0',
};
export const dropDownHeaders = {
  Role: 'Role',
  Status: 'Status',
};

// export const socialImgArr = [
//     {
//         iconName: facebook,
//         link: 'https://www.facebook.com/doitzero',
//         name: 'facebook'
//     },
//     {
//         iconName: linkedin,
//         link: 'https://in.linkedin.com/company/doitzero',
//         name: 'linkedin'
//     },
//     {
//         iconName: twitter,
//         link: 'https://twitter.com/doit_zero',
//         name: 'twitter'
//     },
//     {
//         iconName: instagram,
//         link: 'https://www.instagram.com/doitzero2050/',
//         name: 'instagram'
//     },
//     {
//         iconName: youtube,
//         link: 'https://www.youtube.com/channel/UCdUedjscC1dJ-nbzQWMBAgg',
//         name: 'youtube'
//     }
// ]

// export const detailArr = [
//     {
//         logo: quickonboading,
//         title: 'Quick & Easy Onboarding',
//         subTitle: 'Set up your account with secure access'
//     },
//     {
//         logo: drivenmarketing,
//         title: 'Purpose driven Marketing',
//         subTitle: 'Engage customers through eco-actions'
//     },
//     {
//         logo: consolidated,
//         title: 'Consolidated Reporting',
//         subTitle: 'Get carbon impact reports for stakeholders'
//     }
// ]

export const reportSelect = [
  {
    name: 'This month',
    value: 'monthly',
  },
  {
    name: 'This quarter',
    value: 'quarterly',
  },
  {
    name: 'This year',
    value: 'yearly',
  },
  {
    name: 'All time',
    value: 'alltimes',
  },
];

export const reportSelectAlternative = [
  {
    name: 'Monthly',
    value: new Date().getFullYear(),
  },
  {
    name: 'Quarterly',
    value: 1,
  },
  {
    name: 'Annually',
    value: 0,
  },
];

export const routingList = [
  {
    name: 'categoryManagement',
    moduleName: 'category_management',
  },
  {
    name: 'driverManagement',
    moduleName: 'driver_management',
  },
];

export const months = [
  {
    value: 1,
    month: 'Jan',
    count: 0,
  },
  {
    value: 2,
    month: 'Feb',
    count: 0,
  },
  {
    value: 3,
    month: 'Mar',
    count: 0,
  },
  {
    value: 4,
    month: 'Apr',
    count: 0,
  },
  {
    value: 5,
    month: 'May',
    count: 0,
  },
  {
    value: 6,
    month: 'Jun',
    count: 0,
  },
  {
    value: 7,
    month: 'Jul',
    count: 0,
  },
  {
    value: 8,
    month: 'Aug',
    count: 0,
  },
  {
    value: 9,
    month: 'Sept',
    count: 0,
  },
  {
    value: 10,
    month: 'Oct',
    count: 0,
  },
  {
    value: 11,
    month: 'Nov',
    count: 0,
  },
  {
    value: 12,
    month: 'Dec',
    count: 0,
  },
];

export const quarter = [
  {
    name: 'Q1',
    quarter: 1,
    count: 0,
  },
  {
    name: 'Q2',
    quarter: 2,
    count: 0,
  },
  {
    name: 'Q3',
    quarter: 3,
    count: 0,
  },
  {
    name: 'Q4',
    quarter: 4,
    count: 0,
  },
];

export function getTableTextColor(type) {
  if (type === 'Pending' || type === 'Vendor To Godown') {
    return '#F5921F';
  } else if (type === 'completed' || type === 'Godown Transfer' || type === 'activate' || type === 'opened') {
    return '#48B549';
  } else if (type === 'Delivered') {
    return '#00B41C';
  } else if (type === '36 hrs delayed' || type === 'closed') {
    return '#E01313';
  } else if (type === 'Placed' || type === 'To Customer' || type === 'invite') {
    return '#0084B4';
  } else if (type === 'Godown To Vendor') {
    return '#818181';
  }

  return '#000000';
}

export function getTableCellBgColor(type) {
  if (type === 'completed') {
    return 'rgba(204, 255, 212, 1)';
  } else if (type === 'canceled') {
    return 'rgba(211, 211, 211, 1)';
  }
  return '';
}
